import React from 'react';
import CellAbstract from './CellAbstract';
import { CELL_EXPAND_TEXT_PROPS } from './Types';
import { PuzzleButton } from '../../index';
import HBox from '../../layout/container/h_box/HBox';

/**
 * Component that should be used inside grid if we want to configure specific column to render <button> HTML tag init
 * */
class CellEllipsisExpandText extends CellAbstract<CELL_EXPAND_TEXT_PROPS, {}> {
  textRef;
  /**
   * If true text is overflowing
   */
  isOverflowing;
  constructor(props) {
    super(props);
    this.state = {
      isOverflowing: false
    };
    this.textRef = React.createRef();
  }

  componentDidMount() {
    this.checkOverflow(true);
  }

  componentDidUpdate() {
    this.checkOverflow();
  }

  /**
   * Checks if text is longer then container
   * @param {Boolean} firstLoad
   */
  checkOverflow = (firstLoad?: boolean) => {
    if (this.textRef.current) {
      const isOverflowing = this.textRef.current.scrollWidth > this.textRef.current.clientWidth;
      if (firstLoad) {
        this.isOverflowing = isOverflowing;
      }

      if (isOverflowing !== this.state.isOverflowing) {
        this.setState({ isOverflowing });
      }
    }
  }

  /**
   * Triggers expand text toggle button onClick listener
   */
  toggleExpandCollapse = () => {
    let { dataItem, onExpandTextButtonChange } = this.props;
    dataItem = {
      ...dataItem,
      expandedText: !dataItem.expandedText
    };
    if (onExpandTextButtonChange) {
      onExpandTextButtonChange(dataItem);
    }
  }

  render() {
    const {
      dataIndex,
      dataItem,
      field
    } = this.props;
    const { expandedText } = dataItem;
    const value = dataItem[(field || dataIndex)];
    const { isOverflowing } = this.state;
    if (!isOverflowing && !expandedText) {
      this.isOverflowing = false;
    } else if (isOverflowing && !expandedText) {
      this.isOverflowing = true;
    }

    return (
      <td>
        <HBox
          className='inline-container tp-expand-collapse-text-cell'
          alignItemsStart
        >
          <span
            className={expandedText ? 'tp-auto-height-cell-inner' : 'tp-text-ellipsis inline-text'}
            ref={this.textRef}
          >
            {value}
          </span>
          {this.isOverflowing && (
            <PuzzleButton
              onClick={this.toggleExpandCollapse}
              iconClass='tp-icon tp-ellipsis'
              themeColor={'secondary'}
              fillMode={'flat'}
              className='k-button-xs k-button k-rounded-sm k-icon-button'
            >
            </PuzzleButton>
          )}
        </HBox>
      </td>

    );
  }
}

export default CellEllipsisExpandText;
